import { authApi } from "@/domains/shared/apis/authApi";
import { useQuery } from "@tanstack/react-query";

export type LegalStatus = {
    requiresAcceptance: boolean;
    missing: string[];
    currentTermsVersion: string;
    currentPrivacyVersion: string;
    currentRoleDeclarationVersion: string;
};

export const legalStatusQueryKey = ["auth", "legal-status"] as const;

async function fetchLegalStatus(): Promise<LegalStatus> {
    const { data } = await authApi.getLegalStatus();
    return data;
}

export function useLegalStatus(enabled: boolean) {
    return useQuery({
        queryKey: legalStatusQueryKey,
        queryFn: fetchLegalStatus,
        enabled,
        retry: false,
        staleTime: 60_000,
    });
}
